module.exports = __webpack_public_path__ + "assets/img/5_1339.6414ec7d.jpg";